export default {
  namespaced: true,
  state: {
    areaId: null,
    factoryId: null,
    factories: null,
    factory: null,
    organizationId: null,
    organization: null,
    organizations: null,
    sosPopupActive: false,
  },
  mutations: {
    SET_FACTORY(state, data) {
      state.factory = data;
    },
    SET_FACTORIES(state, data) {
      state.factories = data;
    },
    SET_FACTORY_ID(state, data) {
      state.factoryId = data;
    },
    SET_ORGANIZATION(state, data) {
      state.organization = data;
    },
    SET_ORGANIZATIONS(state, data) {
      state.organizations = data;
    },
    SET_ORGANIZATION_ID(state, data) {
      state.organizationId = data;
    },
    SET_AREA_ID(state, data) {
      state.areaId = data;
    },
    SET_SOS_POPUP_ACTIVE(state, data) {
      state.sosPopupActive = data
    }
    // SET_MODE(state, data) {
    //   state.mode = data;
    // },
  },
  actions: {
    setFactoryId({ commit }, data) {
      commit('SET_FACTORY_ID', data);
    },
    setFactory({ commit }, data) {
      commit('SET_FACTORY', data);
    },
    setFactorys({ commit }, data) {
      commit('SET_FACTORIES', data);
    },
    setOrganizationId({ commit }, data) {
      commit('SET_ORGANIZATION_ID', data);
    },
    setOrganization({ commit }, data) {
      commit('SET_ORGANIZATION', data);
    },
    setOrganizations({ commit }, data) {
      commit('SET_ORGANIZATIONS', data);
    },
    setAreaId({ commit }, data) {
      commit('SET_AREA_ID', data);
    },
    setSosPopupActive({ commit }, data) {
      commit('SET_SOS_POPUP_ACTIVE', data)
    }
    // setMode({ commit }, data) {
    //   commit('SET_MODE', data);
    // },
  },
}